import { isDefined, isNonEmpty } from '@sgme/fp';

import { useOptionSelector } from '@/App/tiles/Option/OptionContext.ts';
import { ErrorRates } from '@/App/tiles/shared/ErrorRates.tsx';
import { getQuote, getRfsId } from '@/store/option/selectors/optionSelectors.ts';

export function StreamingError() {
  const { errorCode, errorMessage, multipassErrorCode, rfsId, predealChecks, isSolving } = useOptionSelector(
    (option) => {
      const currentRfsId = getRfsId(option);

      if (option.properties.rfs.status !== 'ERROR') {
        return {
          errorCode: undefined,
          errorMessage: undefined,
          multipassErrorCode: undefined,
          rfsId: currentRfsId,
          predealChecks: [],
          isSolving: false,
        };
      }

      return {
        errorCode: option.properties.rfs.error.errorCode,
        errorMessage: option.properties.rfs.error.errorMessage,
        multipassErrorCode: option.properties.rfs.error.multipassErrorCode,
        rfsId: currentRfsId,
        predealChecks: getQuote(option)?.predealChecks ?? [],
        isSolving: option.properties.rfs.error.isSolving === true,
      };
    },
  );

  const errorKey = isSolving
    ? 'EM_SOLVING_ERROR'
    : isDefined(errorMessage) && isDefined(errorCode)
      ? computeErrorTranslationKey(errorCode, errorMessage)
      : errorCode;

  const multipass = isDefined(errorCode) ? { code: multipassErrorCode, sessionId: rfsId, predealChecks } : undefined;

  return <ErrorRates code={errorKey} message={errorMessage} multipass={multipass} />;
}

function computeErrorTranslationKey(errorCode: string, errorMessage: string): string {
  const newErrorCode = errorMessage.substring(0, errorMessage.indexOf('|'));

  if (isNonEmpty(newErrorCode)) {
    return `${newErrorCode}_${errorCode}`;
  }

  return errorCode;
}
